document.addEventListener('DOMContentLoaded', function () {
  class CartUpsellSlider extends HTMLElement {
    constructor() {
      super();
      this.sliderRef = this.querySelector('[data-slider]');
      this.paginationRef = this.querySelector('[data-pagination]') || null;
      this.prevRef = this.querySelector('[data-prev]');
      this.nextRef = this.querySelector('[data-next]');
      this.initSlider = this.initSlider.bind(this);
    }

    connectedCallback() {
      this.initSlider();
    }

    initSlider() {
      this.swiper = new Swiper(this.sliderRef, {
        loop: false,
        spaceBetween: 8,
        autoplay: false,
        slidesPerView: 1.3,
        freeMode: true,
        navigation: {
          prevEl: this.prevRef,
          nextEl: this.nextRef,
        },
        pagination: {
          el: this.paginationRef,
          clickable: true,
        },
        mousewheel: {
          forceToAxis: true,
        },
      });
    }

    disconnectedCallback() {
      this.swiper.destroy();
    }
  }
  customElements.define('cart-upsell-slider', CartUpsellSlider);
});
